import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SearchSuggestions from '../../atoms/SearchSuggestions';
import useKeywordSuggestionsLogic, {
  LOGIC_CONSTS,
} from './useKeywordSuggestionsLogic';
import { KEYWORD_INPUT_ID } from '../../constants';
import { getNestedValue } from '../../common/utils/helpers';

const KEYWORD_SUGGESTIONS_OPTIONS = {
  IDS: {
    CATEGORY_SUGGESTIONS: LOGIC_CONSTS.CATEGORY_SUGGESTIONS_ID,
    PROFILE_SUGGESTIONS: LOGIC_CONSTS.PROFILE_SUGGESTIONS_ID,
    RECENT_SEARCHES: LOGIC_CONSTS.RECENT_SEARCHES_ID,
    POPULAR_SEARCHES: LOGIC_CONSTS.POLULAR_SEARCHES_ID,
  },
};

const StyledContainer = styled.div`
  /** COLUMNS  */
  min-width: calc(100% / ${props => props.shownCols});
`;

const KeywordSuggestions = ({
  maxSuggestionTypes,
  suggestionTypeStyles,
  handleSearchResults,
}) => {
  const { allSuggestionTypes, shownCols } = useKeywordSuggestionsLogic({
    maxSuggestionTypes,
  });

  return (
    <>
      {allSuggestionTypes.map(suggestionType => (
        <StyledContainer key={suggestionType.id} shownCols={shownCols}>
          <SearchSuggestions
            emphasis={getNestedValue(
              suggestionTypeStyles,
              suggestionType.id,
              'emphasis'
            )}
            fieldId={KEYWORD_INPUT_ID}
            handleSuggestionClick={suggestion => {
              suggestionType.handleSuggestionClick(suggestion);
              handleSearchResults(suggestionType.id);
            }}
            heading={getNestedValue(
              suggestionTypeStyles,
              suggestionType.id,
              'heading'
            )}
            highlightMatch={getNestedValue(
              suggestionTypeStyles,
              suggestionType.id,
              'highlightMatch'
            )}
            hoverIcon={getNestedValue(
              suggestionTypeStyles,
              suggestionType.id,
              'hoverIcon'
            )}
            suggestions={suggestionType.suggestions}
          />
        </StyledContainer>
      ))}
    </>
  );
};

const suggestionTypeStylesOptionsPropTypes = {
  emphasis: PropTypes.bool,
  heading: PropTypes.string,
  highlightMatch: PropTypes.bool,
  hoverIcon: PropTypes.bool,
};
const keywordSuggestionsPropTypes = {
  handleSearchResults: PropTypes.func,
  maxSuggestionTypes: PropTypes.number,
  suggestionTypeStyles: PropTypes.shape({
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.CATEGORY_SUGGESTIONS]: PropTypes.shape(
      suggestionTypeStylesOptionsPropTypes
    ),
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.PROFILE_SUGGESTIONS]: PropTypes.shape(
      suggestionTypeStylesOptionsPropTypes
    ),
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.RECENT_SEARCHES]: PropTypes.shape(
      suggestionTypeStylesOptionsPropTypes
    ),
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.POPULAR_SEARCHES]: PropTypes.shape(
      suggestionTypeStylesOptionsPropTypes
    ),
  }),
};
const keywordSuggestionsDefaultProps = {
  handleSearchResults: () => {},
  maxSuggestionTypes: 3,
  suggestionTypeStyles: {
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.CATEGORY_SUGGESTIONS]: {},
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.PROFILE_SUGGESTIONS]: {},
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.RECENT_SEARCHES]: {},
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.POPULAR_SEARCHES]: {},
  },
};

KeywordSuggestions.propTypes = keywordSuggestionsPropTypes;
KeywordSuggestions.defaultProps = keywordSuggestionsDefaultProps;
export default KeywordSuggestions;
export {
  KEYWORD_SUGGESTIONS_OPTIONS,
  keywordSuggestionsDefaultProps,
  keywordSuggestionsPropTypes,
};
